import { EPAPER_CATEGORY_FETCH_DATA_SUCCESS, EPAPER_CATEGORY_HAVE_ERROR, EPAPER_CATEGORY_ARE_LOADING } from '../actionType';
import HttpService from '../../utils/httpService';
import { Get } from '../../services/api.service'

export function ePaperCategoryAction(action, payload) {
    switch (action) {
        case EPAPER_CATEGORY_HAVE_ERROR:
            return {
                type: action,
                hasError: payload
            };

        case EPAPER_CATEGORY_ARE_LOADING:
            return {
                type: action,
                isLoading: payload
            };

        case EPAPER_CATEGORY_FETCH_DATA_SUCCESS:
            return {
                type: action,
                epaperCategory: payload || {},
            };

        default:
            return;
    }
}

export function epaperCategoryFetchData(ePaperDetails) {
    return (dispatch) => {
        dispatch(ePaperCategoryAction(EPAPER_CATEGORY_FETCH_DATA_SUCCESS, {}));
        try {
            return new Promise((resolve, reject) => {
                // dispatch(ePaperCategoryAction(EPAPER_CATEGORY_ARE_LOADING, true));
                Get(HttpService.epaperCategory_V2 + ePaperDetails).then((result) => {
                    dispatch(ePaperCategoryAction(EPAPER_CATEGORY_FETCH_DATA_SUCCESS, result));
                    resolve(result);
                }, (error) => {
                    reject(error);
                });
            });
        } catch (error) {
            dispatch(ePaperCategoryAction(EPAPER_CATEGORY_HAVE_ERROR, true));
        }
    }
}

export function epaperCategoryClear() {
    return (dispatch) => {
        dispatch(ePaperCategoryAction(EPAPER_CATEGORY_FETCH_DATA_SUCCESS, {}));
    }
}
